import { render, staticRenderFns } from "./AssessListModal.vue?vue&type=template&id=097aff48&"
import script from "./AssessListModal.vue?vue&type=script&lang=js&"
export * from "./AssessListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports